exports.connect = {
	url: "https://api.belair.camp/"
}
